<template>
  <el-dialog
    :title="`客户信息上报（${customerName}）`"
    :visible.sync="visible"
    append-to-body
    width="1100px"
    @close="$emit('update:show', false)"
  >
    <IssueList
      :customerID="customerID"
      :orderID="orderID"
      :search="false"
    ></IssueList>
  </el-dialog>
</template>

<script>
import IssueList from '@/views/customer/issue'

export default {
  components: {
    IssueList,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customerID: {
      type: Number,
      default: 0,
    },
    orderID: {
      type: Number,
      default: 0,
    },
    customerName: String,
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: this.show,
    }
  },
  created() {},
  methods: {},
}
</script>

<style scoped>
.el-dialog__body .panel {
  padding: 0;
  box-shadow: none;
}
</style>